import type { ComponentType } from 'react';
import AppShellLayoutForSSR from '../../components/layout/AppShellLayoutForSSR';
import NotFound from '../../pages/404';
import type { WithCommonNextPage } from './withProfileUserProps';

export function withRemovedPageFallback<P extends object = NonNullable<unknown>>(
  WrappedComponent: WithCommonNextPage<P>,
) {
  const Component = WrappedComponent as ComponentType<Record<string, unknown>>;

  const EnhancedComponent: WithCommonNextPage<P> = (props) => {
    /**
     * 페이지의 응답 status code 410 일 경우에 대한 렌더링 분기
     * @TODO 삭제된 페이지라는 것을 알릴 필요가 있을지? 404 로 렌더링 되어도 괜찮을지?
     */
    if (props.isRemovePage) {
      return <NotFound />;
    }

    // 기본 컴포넌트 렌더링
    return (
      <AppShellLayoutForSSR footer={{ isVisible: false, hasBottomNavigation: false }}>
        <Component {...props} />
      </AppShellLayoutForSSR>
    );
  };
  return EnhancedComponent;
}
